import { useAppSelector } from '@/redux/rootReducer'
import { selectConsultationById, selectParticipantsByConsultationId } from '@/redux/reducers/consultation.reducer'
import { selectRoomByConsultationId } from '@/redux/reducers/room.reducer'
import { selectUnreadMessagesByChatRoom } from '@/redux/reducers/chat-room.reducer'

export function useConsultationState(consultationId?: string) {
  const consultation = useAppSelector((state) => (consultationId ? selectConsultationById(state, consultationId) : undefined))
  const room = useAppSelector((state) => (consultationId ? selectRoomByConsultationId(state, consultationId) : undefined))
  const participants = useAppSelector((state) => (consultationId ? selectParticipantsByConsultationId(state, consultationId) : undefined))
  const unreadChatMessages = useAppSelector((state) => (consultation?.chatRoom ? selectUnreadMessagesByChatRoom(state, consultation.chatRoom) : []))

  return {
    consultation,
    room,
    participants,
    unreadChatMessages,
  }
}
